import CancellationPolicies from './CancellationPolicies';

export default CancellationPolicies;
